export const AMAZON_BUTTON_ID_V2 = 'AmazonPayButtonMethodV2';
export const AMAZON_URL_PARAM = {
    PAYMENT_CONFIRMED: 'paymentConfirmed',
    SESSION_ID: 'amazonCheckoutSessionId',
};

export const CHANGE_ADDRESS_BUTTON_ID = 'amazonChangeAddress';
export const CHANGE_PAYMENT_BUTTON_ID = 'amazonChangePayment';
